import { createRouter, createWebHistory } from 'vue-router';
import { useSecurityStore } from '@/dod/store/dsecurity';
import settings from '@/settings/settings';

const ColorsDemo = () => import("../views/ColorsDemo.vue");

const FrontMaster = () => import(/* webpackChunkName: "frontmaster" */ "../views/front/FrontMaster.vue");
const LoginView = () => import(/* webpackChunkName: "login-account-handle" */ "../views/front/LoginView.vue");
const ForgotPasswordView = () => import(/* webpackChunkName: "login-account-handle" */ "../views/front/ForgotPasswordView.vue");
const RegisterAccountView = () => import(/* webpackChunkName: "login-account-handle" */ "../views/front/RegisterAccountView.vue");

/* APP */

const AppMaster = () => import(/* webpackChunkName: "appmaster" */ "../views/app/AppMaster.vue");
const HomeView = () => import(/* webpackChunkName: "home" */ "../views/app/home/HomeView.vue");
const AccountView = () => import(/* webpackChunkName: "account" */ "../views/app/account/AccountView.vue");
const GamesView = () => import(/* webpackChunkName: "games" */ "../views/app/games/GamesView.vue");
const RulesViewer = () => import(/* webpackChunkName: "rules" */ "../views/app/games/RulesViewer.vue");
const StatisticsViewer = () => import(/* webpackChunkName: "statistics" */ "../views/app/statistics/StatisticsViewer.vue");
const GameBoard = () => import(/* webpackChunkName: "gameboard" */ "../views/app/games/GameBoard.vue");

/* ERROR */
const ErrorView = () => import(/* webpackChunkName: "error" */ "../views/app/miscellaneous/ErrorView.vue");

const routes = [
  {
    name: "frontmaster",
    path: "/loggain",
    component: FrontMaster,
    redirect: { path: "/loggain" },
    children: [{
        path: "/loggain",
        name: "Loggain",
        component: LoginView
    },
    {
        path: "/glomt-losenord/:token?",
        name: "GlomLosenord",
        component: ForgotPasswordView
    },
{
        path: "/skapa-konto/:token?",
        name: "SkapaKonto",
        component: RegisterAccountView
    }]
  },
  {
    name: "appmaster",
    path: "/",
    component: AppMaster,
    redirect: { path: "/" },
    children: [
        {
            path: "/",
            name: "Home",
            component: HomeView
        },                    
        {
            path: "/start",
            name: "Start",
            component: HomeView
        },
        {
            path: "/konto",
            name: "Account",
            component: AccountView
        },  
        {
            path: "/spel",
            name: "GamesSelect",
            props: { selectType: "game"},
            component: GamesView
        },         
        {
            path: "/regler",
            name: "RulesSelect",
            props: { selectType: "rules"},
            component: GamesView
        },       
        {
            path: "/statistik",
            name: "StatisticsSelect",
            props: { selectType: "statistics"},
            component: GamesView
        }, 
        {
            path: "/spel/:id/:name",
            name: "GameSelect",            
            component: GamesView,
            props: true
        },  
        {
            path: "/spel/:id/:name/:gameid?",
            name: "GamePlay",            
            component: GameBoard,
            props: true
        },  
        {
             path: "/regler/:id/:name", 
             name: "RulesViewer",
             component: RulesViewer, 
             props: true
        },
        {
            path: "/statistik/:id/:name/:players?/:placement?", 
            name: "StatisticsViewer",
            component: StatisticsViewer, 
            props: true
       },
        {
            path: "/:catchAll(.*)",
            component: ErrorView
        }
    ]
}   ,
{
    name : "ColorsDemo",
    path: "/colorsdemo",
    component: ColorsDemo
}
];

const router = createRouter({
  history: createWebHistory(),
  routes,  
  scrollBehavior(to, from, savedPosition)
    {
        if (savedPosition)
        {
            return savedPosition;
        } else
        {
            return { x: 0, y: 0 };
        }
    }
});

router.beforeEach((to, from, next) =>
{        
    if(settings.default.colors_demo){
        if(to.path != "/colorsdemo")
            next({path: "/colorsdemo"});
        else 
            next();
        return;
    }

    var secStore = useSecurityStore();
    const publicPages =  settings.default.public_pages;
    const loggedIn = secStore.token;
    var isPublicPage = checkPage(publicPages, to.path);

    if (isPublicPage && !loggedIn)
    {
        next();
        return;
    }

    if (loggedIn)
    {
        if(isPublicPage)
            next({path: "/"});
        else 
            next();
        return;
    }

    // If not logged in and trying to access a page that is nog public
    if (!loggedIn)
    {
        //store.dispatch("auth/logout");
        if (to.path != "" && to.path != "/")
            next({ path: "/loggain", query: { redirect: to.path } }); // Redirect to login page
        else
            next({ path: "/loggain" }); // Redirect to login page
        return;
    }
});

export default router;

function checkPage(pages, path)
{
    for (var i = 0; i < pages.length; i++)
    {
        var page = pages[ i ];
        if (path.includes(page))
            return true;
    }
    return false;
}